const namedRoutes = {};
export {
  namedRoutes
};
